import { Route, Routes } from "react-router-dom";
import type { ReactNode } from "react";
import { RoleArea } from "./components/RoleLayout";
import { AREA_SEGMENT } from "./components/nav";
import { LandingPage, LoginPage, RegisterPage } from "./pages/AuthPages";
import { MenuPage, NotFoundPage } from "./pages/MiscPages";
import { PublicTenantPage } from "./pages/PublicTenantPage";
import {
  PatientAppointmentsPage,
  PatientBookingDetailPage,
  PatientBookingPage,
  PatientHistoryPage,
  PatientHomePage,
  PatientPayPage,
  PatientProfilePage,
} from "./pages/PatientPages";
import {
  AdminBookingsPage,
  AdminDashboardPage,
  AdminPaymentsPage,
  AdminSchedulePage,
  AdminServicesPage,
  AdminSettingsPage,
  AdminTherapistsPage,
} from "./pages/AdminPages";
import {
  TherapistAppointmentsPage,
  TherapistSchedulePage,
  TherapistTodayPage,
} from "./pages/TherapistPages";
import {
  PlatformDashboardPage,
  PlatformTenantsPage,
} from "./pages/PlatformPages";
import { NotificationsPage } from "./pages/NotificationsPage";
import { ProfilePage } from "./pages/ProfilePage";
import type { UserRole } from "./api/types";

/** Route child area per role: path relatif → element. */
const AREA_ROUTES: Record<UserRole, Array<[string, ReactNode]>> = {
  PATIENT: [
    ["", <PatientHomePage key="h" />],
    ["booking", <PatientBookingPage key="b" />],
    ["appointments", <PatientAppointmentsPage key="a" />],
    ["appointments/:id", <PatientBookingDetailPage key="d" />],
    ["history", <PatientHistoryPage key="y" />],
    ["pay/:bookingId", <PatientPayPage key="p" />],
    ["profile", <PatientProfilePage key="pr" />],
  ],
  THERAPIST: [
    ["", <TherapistTodayPage key="t" />],
    ["jadwal", <TherapistSchedulePage key="j" />],
    ["appointments", <TherapistAppointmentsPage key="a" />],
    ["profile", <ProfilePage key="pr" />],
  ],
  TENANT_ADMIN: [
    ["", <AdminDashboardPage key="d" />],
    ["bookings", <AdminBookingsPage key="bk" />],
    ["therapists", <AdminTherapistsPage key="th" />],
    ["services", <AdminServicesPage key="sv" />],
    ["schedule", <AdminSchedulePage key="sc" />],
    ["payments", <AdminPaymentsPage key="pm" />],
    ["settings", <AdminSettingsPage key="st" />],
    ["profile", <ProfilePage key="pr" />],
  ],
  SUPER_ADMIN: [
    ["", <PlatformDashboardPage key="d" />],
    ["tenants", <PlatformTenantsPage key="t" />],
    ["profile", <ProfilePage key="pr" />],
  ],
};

const ALL_ROLES: UserRole[] = ["PATIENT", "THERAPIST", "TENANT_ADMIN", "SUPER_ADMIN"];

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/t/:slug" element={<PublicTenantPage />} />

      {ALL_ROLES.map((role) => {
        const segment = AREA_SEGMENT[role];
        return (
          <Route key={role} path={`/${segment}`} element={<RoleArea role={role} />}>
            {AREA_ROUTES[role].map(([path, element]) => (
              <Route key={path || "index"} path={path || undefined} index={path === ""} element={element} />
            ))}
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="menu" element={<MenuPage />} />
          </Route>
        );
      })}

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
